function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "local_florist_24px"
}, React.createElement("path", {
  id: "icon/maps/local_florist_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.09997 13.25C6.71997 13.25 5.59997 12.13 5.59997 10.75C5.59997 9.75 6.18994 8.90002 7.03002 8.5C6.18994 8.09998 5.59997 7.25 5.59997 6.25C5.59997 4.87 6.71997 3.75 8.09997 3.75C8.63 3.75 9.11999 3.90997 9.52001 4.19L9.5 4C9.5 2.62 10.62 1.5 12 1.5C13.38 1.5 14.5 2.62 14.5 4L14.48 4.19C14.89 3.90997 15.37 3.75 15.9 3.75C17.28 3.75 18.4 4.87 18.4 6.25C18.4 7.25 17.8099 8.09998 16.97 8.5C17.8099 8.90002 18.4 9.75 18.4 10.75C18.4 12.13 17.28 13.25 15.9 13.25C15.37 13.25 14.88 13.09 14.48 12.81L14.5 13C14.5 14.38 13.38 15.5 12 15.5C10.62 15.5 9.5 14.38 9.5 13L9.52001 12.81C9.10998 13.09 8.63 13.25 8.09997 13.25ZM20.92 14.7C20.33 19.1 16.5601 22.5 12 22.5C12 17.94 15.4 14.17 19.8 13.58C20.4399 13.49 21.01 14.06 20.92 14.7ZM12 22.5C12 17.94 8.59997 14.17 4.19995 13.58C3.55993 13.49 2.98999 14.06 3.07995 14.7C3.66992 19.1 7.43994 22.5 12 22.5ZM12 6C13.38 6 14.5 7.12 14.5 8.5C14.5 9.88 13.38 11 12 11C10.62 11 9.5 9.88 9.5 8.5C9.5 7.12 10.62 6 12 6Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgRevegetasi = function SvgRevegetasi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRevegetasi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/revegetasi.80aa13b0.svg";
export { ForwardRef as ReactComponent };